<template>
    <section class="tui-hint fix non">
        <div class="opc"></div>
        <div class="dialog white1 br3 abs ct">
            <img class="fr cp" src="img/gen/ico_guanbi.png" @click="close()">
            <p>{{hintCon}}</p>
            <div class="first fr cp" @click="confirm()">确定</div>
            <div class="last fr cp" @click="close()">取消</div>
        </div>
    </section>
</template>
<script>
//子组件如果和父组件引用同一个 js 组件，方法可以用，
//实例化出来的，数据不一样。所以这里调用 tui-common.js 没有意义
export default {
    name: "Hint",
    mounted() {
        window.tuiHint = window.$('.tui-hint');
        if (this.$route.name != 'editImg') {
            this.hintCon = '将会清空文件列表，确定要放弃当前任务吗？';
        }
    },
    props: ['chanImg', 'delImg', 'toHeic', 'toCommon'],
    data() {
        return {
            hintCon: '当前编辑的内容未保存，确定要切换吗？'
        };
    },
    methods: {
        close() {
            window.tuiHint.hide();
            window.picAction = '';
        },
        confirm() {
            function jQ(str) {
                return window.$(str);
            }
            var _this = this;
            var inpFileLoad = jQ(".tui-image-editor-load-btn");
            window.tuiHint.hide();
            switch (window.picAction) {
                //转换页里的 heic 跳转
                case 'heic':
                    _this.toHeic();
                    break;
                case 'common':
                    _this.toCommon();
                    break;
                //三个页面跳转
                case 'editImg':
                    window.editorUrls = [];
                    _this.$router.push({
                        name: 'editImg'
                    });
                    break;
                case 'transform':
                    //每次调起提示框，都会重赋值，所以不需要还原
                    //文件列表一定要清理，不能有残留
                    window.editorUrls = [];
                    _this.$router.push({
                        name: 'transform'
                    });
                    break;
                case 'compress':
                    window.editorUrls = [];
                    _this.$router.push({
                        name: 'compress'
                    });
                    break;
                //图片编辑页底下列表切换
                case 'newPic':
                    inpFileLoad.first().click();
                    break;
                case 'delPic':
                    _this.delImg();
                    break;
                case 'chanPic':
                    _this.chanImg();
                    break;
            }
        }
    }
};
</script>

<style scoped>
.tui-hint {
    width: 100%;
    height: 100%;
    z-index: 5;
}
.opc {
    width: 100%;
    height: 100%;
    background-color: #000;
}
.dialog {
    width: 335px;
    height: 162px;
    left: 428px;
    top: 200px;
    line-height: 26px;
}
.dialog img {
    padding: 16px;
}
.dialog p {
    margin-top: 55px;
}
.dialog div {
    margin-top: 46px;
}
.dialog p,
.dialog div {
    font-size: 14px;
    color: #464851;
}
.dialog .first {
    margin-right: 25px;
}
.dialog .last {
    margin-right: 35px;
}
</style>